import React, { Component } from "react";
import PropTypes from "prop-types";
import Modal from "../Modal/Modal";

class ConfirmationModal extends Component {
	constructor(props) {
		super(props);
		const { lang } = global;

		this.state = {
			show: false,
			hideCancel: false,
			hideConfirm: false,
			onHide: undefined,
			onConfirm: () => {},
			onCancel: () => {},
			enforceFocus: true,
			title: lang.t("Confirm"),
			message: "", // Replaces subTitle
			confirmButton: lang.t("OK"), // replaces confirmationButton
			cancelButton: lang.t("Cancel"),
		};
	}

	openModal = settings => {
		this.setState(prevState => ({
			...prevState,
			show: true,
			...settings,
		}));
	};

	hideAction = () => {
		const { onHide, onCancel } = this.state;
		this.setState({ show: false }, onHide instanceof Function ? onHide() : onCancel());
	};

	cancelAction = () => {
		const { onCancel } = this.state;
		this.setState({ show: false }, onCancel);
	};

	confirmAction = () => {
		const { onConfirm } = this.state;
		this.setState({ show: false }, onConfirm);
	};

	/** Reset component state to default values */
	onExited = () => {
		const { lang } = global;
		this.setState({
			show: false,
			hideCancel: false,
			onHide: undefined,
			onConfirm: () => {},
			onCancel: () => {},
			enforceFocus: true,
			title: lang.t("Confirm"),
			message: "",
			confirmButton: lang.t("OK"),
			cancelButton: lang.t("Cancel"),
		});
	};

	render() {
		const { size } = this.props;
		const {
			show,
			hideCancel,
			hideConfirm,
			enforceFocus,
			title,
			message,
			confirmButton,
			cancelButton,
		} = this.state;

		return (
			<Modal
				show={show}
				onHide={this.hideAction}
				onExited={this.onExited}
				size={size}
				enforceFocus={enforceFocus}
			>
				<Modal.Header>
					<Modal.Title>{title}</Modal.Title>
				</Modal.Header>
				<Modal.Body className="text-center">{message}</Modal.Body>
				<Modal.Footer>
					<If condition={!hideCancel}>
						<button
							id="confirmation-modal-cancel-button"
							type="button"
							className="btn btn-link"
							onClick={this.cancelAction}
						>
							{cancelButton}
						</button>
					</If>
					<If condition={!hideConfirm}>
						<button
							id="confirmation-modal-confirm-button"
							type="button"
							className="btn btn-primary"
							onClick={this.confirmAction}
							data-test-id="confirmation-modal__confirm-button"
						>
							{confirmButton}
						</button>
					</If>
				</Modal.Footer>
			</Modal>
		);
	}
}

ConfirmationModal.propTypes = {
	size: PropTypes.oneOf(["sm", "lg"]),
};

ConfirmationModal.defaultProps = {
	size: undefined,
};

export default ConfirmationModal;
